import { createContext } from "react"

export const ServerRenderedProps = createContext()
